var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "reviews" } },
    [
      _vm.loading
        ? _c("div", [_c("device-filter-reviews-skeleton")], 1)
        : [
            _c(
              "div",
              { staticClass: "pb-2" },
              [
                _c("p", { staticClass: "fw-bold pb-0" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.reviewsMessages.sortTitle) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("ob1-radio-button-list", {
                  attrs: { "radios-buttons": _vm.radioButtons },
                  on: { change: _vm.reviewDateSortHandler },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.ratingsFilterCheckBoxes.length > 0
              ? [
                  _c("hr", { staticClass: "mb-2 separator separator--gray4" }),
                  _vm._v(" "),
                  _c("p", { staticClass: "fw-bold pb-0" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.reviewsMessages.ratingsFilterTitle) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "items-list" },
                    [
                      _vm._l(_vm.ratingsFilterCheckBoxes, function (rating) {
                        return [
                          _c("li", { key: rating.id }, [
                            _c("div", { staticClass: "items-list-item" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "item-container item-container-sm",
                                },
                                [
                                  _c("ob1-check-box2", {
                                    attrs: {
                                      id: _vm.device + "-" + rating.id,
                                      name: _vm.device + "-rating-" + rating.id,
                                      label: _vm.getCountLabel(
                                        rating.label,
                                        rating.count
                                      ),
                                      "is-indeterminated":
                                        rating.isIndeterminated,
                                      "aria-labelled-by": _vm.getCountLabel(
                                        rating.label,
                                        rating.count
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.ratingFilterHandler(
                                          rating.label,
                                          rating.isChecked
                                        )
                                      },
                                    },
                                    model: {
                                      value: rating.isChecked,
                                      callback: function ($$v) {
                                        _vm.$set(rating, "isChecked", $$v)
                                      },
                                      expression: "rating.isChecked",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "item-text",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getCountLabel(
                                          rating.label,
                                          rating.count
                                        )
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }